/**
 * Lightweight pub/sub so Attendance timeline actions (e.g. Relogin from a message)
 * can refresh the bottom Attendance action bar without a full page reload.
 */
const EVENT = 'workloop:attendance-session-changed';
const TEAM_LIVE_EVENT = 'workloop:team-live-status-changed';

export const notifyAttendanceSessionChanged = (detail = null) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(EVENT, { detail: detail || {} }));
};

export const subscribeAttendanceSessionChanged = (handler) => {
  if (typeof window === 'undefined') return () => {};
  const listener = (event) => handler(event.detail || {});
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
};

/** Notify team roster / live status views that a member's attendance or presence changed. */
export const notifyTeamLiveStatusChanged = (detail = null) => {
  if (typeof window === 'undefined' || !detail) return;
  window.dispatchEvent(new CustomEvent(TEAM_LIVE_EVENT, { detail }));
};

export const subscribeTeamLiveStatusChanged = (handler) => {
  if (typeof window === 'undefined') return () => {};
  const listener = (event) => handler(event.detail || {});
  window.addEventListener(TEAM_LIVE_EVENT, listener);
  return () => window.removeEventListener(TEAM_LIVE_EVENT, listener);
};

export default {
  notifyAttendanceSessionChanged,
  subscribeAttendanceSessionChanged,
  notifyTeamLiveStatusChanged,
  subscribeTeamLiveStatusChanged,
};
